import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { QuoteStatusEnum } from '../../enum/quote-status.enum';
import { AirlineResponseRateRequest } from '../../model/airline-response-rate-request.model';
import { AirlineResponseRate } from '../../model/airline-response-rate.model';
import { IAirlineBrand, IAirlineConfig } from '../../model/airline.model';
import { IPresignedURL } from '../../model/presigned-url.model';
import { IAirlineScheduleAttachment } from '../../model/airline-schedule-attachment.model';
import { IPresignedAirlineScheduleAttachment } from '../../model/presigned-airline-schedule-attachment.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class AirlineService {
  async getAirlines(): Promise<IAirlineBrand[]> {
    return CaiApi.get(API_CORE.name, API_CORE.URLs.Airline.Airlines, {});
  }
  async getAirlineConfig(
    airlineId: string,
    provider: string,
    country: string,
    status: QuoteStatusEnum,
  ): Promise<IAirlineConfig> {
    if (provider.includes('MOCK')) {
      provider = 'MOCK';
    }
    const extraOptions = {
        queryParams: {
          provider,
          country,
          status,
        },
      },
      url = API_CORE.URLs.Airline.AirlineConfig.replace(
        '{airlineId}',
        airlineId,
      );
    return CaiApi.get(API_CORE.name, url, extraOptions);
  }

  async calculateResponseRate(
    request: AirlineResponseRateRequest,
  ): Promise<AirlineResponseRate[]> {
    const extraOptions = {
      body: request,
    };
    return CaiApi.post(
      API_CORE.name,
      API_CORE.URLs.Airline.ResponseRate,
      extraOptions,
    );
  }

  async generateUploadUrlForScheduleAttachment(
    airlineBrandId: number,
    attachment: IAirlineScheduleAttachment,
  ): Promise<IPresignedAirlineScheduleAttachment> {
    const url = API_CORE.URLs.Airline.UploadScheduleAttachment.replace(
      '{airlineBrandId}',
      airlineBrandId.toString(),
    );
    return CaiApi.post(API_CORE.name, url, {
      body: attachment,
    });
  }
  async generateDownloadUrlForScheduleAttachment(
    airlineBrandId: number,
    attachmentId: number,
    token?: string,
  ): Promise<IPresignedURL> {
    const url = API_CORE.URLs.Airline.DownloadScheduleAttachment.replace(
      '{attachmentId}',
      attachmentId.toString(),
    );
    let extraOptions = {};
    if (token) {
      extraOptions = {
        queryParams: { token },
      };
    }
    return CaiApi.get(API_CORE.name, url, extraOptions);
  }

  async deleteScheduleAttachment(
    airlineBrandId: number,
    attachmentId: number,
  ): Promise<any> {
    const url = API_CORE.URLs.Airline.DeleteScheduleAttachment.replace(
      '{airlineBrandId}',
      airlineBrandId.toString(),
    )
      .concat('/')
      .concat(attachmentId.toString());
    return CaiApi.del(API_CORE.name, url, {});
  }
}
